import React from 'react';
import { motion } from 'framer-motion';
import './Atouts.css';
import { LuBriefcaseMedical, LuClipboardList, LuDog, LuHeadset, LuLocate, LuMedal } from 'react-icons/lu';

const ATOUTS = [
  {
    icon: <LuDog />,
    title: 'Bien-être animal au cœur',
    desc: 'Chaque animal est traité comme un être vivant précieux. Nos protocoles garantissent confort, calme et sécurité à chaque étape du voyage.',
    stat: '0%',
    statLabel: 'Incident déclaré',
  },
  {
    icon: <LuBriefcaseMedical /> ,
    title: 'Expertise vétérinaire',
    desc: 'Notre réseau de vétérinaires partenaires assure un suivi médical avant, pendant et après le transport pour les animaux nécessitant une attention particulière.',
    stat: '48h',
    statLabel: 'Bilan pré-voyage',
  },
  {
    icon: <LuMedal />,
    title: 'Certifié IATA Live Animals',
    desc: "Nous respectons à la lettre les réglementations IATA pour le transport d'animaux vivants, garantissant conformité avec les normes internationales les plus strictes.",
    stat: 'IATA',
    statLabel: 'Certifié depuis 2008',
  },
  {
    icon: <LuClipboardList/> ,
    title: 'Gestion documentaire totale',
    desc: "Passeports, vaccinations, certificats sanitaires, permis CITES : nous prenons en charge l'intégralité des démarches administratives.",
    stat: '100%',
    statLabel: 'Docs pris en charge',
  },
  {
    icon: <LuLocate/>,
    title: 'Suivi en temps réel',
    desc: 'Une interface de tracking dédiée vous permet de suivre votre animal tout au long du trajet, avec des notifications à chaque étape clé.',
    stat: '24/7',
    statLabel: 'Suivi live',
  },
  {
    icon: <LuHeadset/>,
    title: 'Accompagnement personnalisé',
    desc: 'Un conseiller dédié répond à toutes vos questions avant le départ et reste joignable pendant toute la durée du transport.',
    stat: '<2h',
    statLabel: 'Délai de réponse',
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

export default function Atouts({ trackEvent }) {
  return (
    <section id="atouts" className="atouts" data-tracking-name="Atouts">
      {/* Fond décoratif */}
      <div className="atouts-bg-shape" />
      <img className='vector-one' src={require('../../assets/dog.png')} alt='Dog'/>

      <div className="atouts-container">
        {/* En-tête */}
        <motion.div
          className="atouts-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label">Pourquoi nous choisir</span>
          <h2 className="section-title">
            L'excellence à chaque<br />étape du voyage
          </h2>
          <p className="atouts-intro">
            Plus de 15 ans d'expertise au service des animaux et de leurs propriétaires.
            Notre engagement : un transport irréprochable, une tranquillité d'esprit totale.
          </p>
        </motion.div>

        {/* Grille atouts */}
        <motion.div
          className="atouts-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-60px' }}
        >
          {ATOUTS.map((atout) => (
            <motion.div
              key={atout.title}
              className="atout-card"
              variants={itemVariants}
              whileHover={{ y: -4, transition: { duration: 0.25 } }}
            >
              <div className="atout-top">
                <span className="atout-icon">{atout.icon}</span>
                <div className="atout-stat-box">
                  <span className="atout-stat-value">{atout.stat}</span>
                  <span className="atout-stat-label">{atout.statLabel}</span>
                </div>
              </div>
              <h3 className="atout-title">{atout.title}</h3>
              <p className="atout-desc">{atout.desc}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Bandeau de confiance
        <motion.div
          className="trust-banner"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <div className="trust-inner">
            {[
              { label: 'IATA Live Animals Regulations', logo: '🏅' },
              { label: 'IPATA Member', logo: '🌐' },
              { label: 'TRACES Certifié', logo: '🇪🇺' },
              { label: 'Assurance Cargo Pro', logo: '🛡️' },
            ].map((cert) => (
              <div key={cert.label} className="trust-item">
                <span className="trust-logo">{cert.logo}</span>
                <span className="trust-label">{cert.label}</span>
              </div>
            ))}
          </div>
        </motion.div> */}
      </div>
    </section>
  );
}
